import { Box } from "@mui/material";

import GoStarCard from "./GoStarCard";
import ReachCard from "./ReachCard";
import AdCard from "./AdCard";

const AdvertisementCol = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "217px",
        height: "100%",
      }}
    >
      <GoStarCard />
      <AdCard />
      <ReachCard />
    </Box>
  );
};

export default AdvertisementCol;
